import React, { useState } from 'react'
import baseUrl from '../Constant';
import { useNavigate } from 'react-router-dom';
import axios from 'axios'
import { useGlobalContext } from './Context';

function Login() {
    const { login, message, color } = useGlobalContext();


    // function handleLogin(e) {
    //     e.preventDefault()
    //     const email = e.target.email.value;
    //     const password = e.target.password.value;
    //     axios.post(`${baseUrl}/accounts/drlogin`, { email, password })
    //         .then((res) => {
    //             console.log(res.data)
    //             setMessage(res.data.message)
    //             if (res.data.status === 200) {
    //                 setColor("green");
    //                 console.log('green')
    //                 localStorage.setItem('token', JSON.stringify(res.data.access));
    //                 setTimeout(() => {
    //                     navigate("dashboard")
    //                 }, 2000);
    //                 // setIsLoggedin(true);
    //             } else {
    //                 setColor("red")
    //                 console.log('red')
    //             };
    //             // if (res.data.status === 400) {
    //             //     setColor("red");
    //             //     console.log('red')
    //             //     setTimeout(() => {
    //             //         setMessage('')
    //             //         setColor("");
    //             //     }, 3000);
    //             // } else {
    //             //     setColor("green")
    //             //     console.log('green')
    //             // }
    //         })
    //         .catch((error) => {
    //             console.log(error)
    //         })
    // }
    const handleLogin = (e) => {
        e.preventDefault();
        const email = e.target.email.value;
        const password = e.target.password.value;
        login(email, password);
      
    };
  

    return (
        <div style={{ backgroundColor: "#0d1b2a", height: '100vh' }}>
            <div style={{ padding: "40px" }}>
                <h1 style={{ textAlign: "center", color: "white", letterSpacing: "10px" }}>SIGN IN</h1>
            </div>
            <div>
                <h1 style={{ color: `${color}`, fontSize: "1.5rem", textAlign: "center" }}>{message}</h1>
            </div>
            <div className="login-box">
                <form
                    onSubmit={handleLogin}
                >
                    <div className="user-box">
                        <input type="email" name="email" id='email' required />
                        <label style={{ color: "white", fontWeight: "500" }}>Username</label>
                    </div>
                    <div className="user-box">
                        <input type="password" name="password" id='password' required />
                        <label style={{ color: "white", fontWeight: "500" }}>Password</label>
                    </div>
                    <div style={{ textAlign: "center" }}>
                        <button type="submit" className='btnlogin'>LOGIN</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default Login;